import { Injectable } from '@angular/core';
import { COMPANY_NAMES, Configuration } from '@app/config';

@Injectable()
export class MenuService {

    menuItems: Array<any>;
    COMPANY_NAME = Configuration.COMPANY_NAME;
    COMPANY_NAMES = COMPANY_NAMES;
    constructor() {
        this.menuItems = [];
    }

    addMenu(items: Array<{
        text: string,
        heading?: boolean,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        submenu?: Array<any>
    }>) {
        items.forEach((item) => {
            if(this.COMPANY_NAME==COMPANY_NAMES.THE_ENT && item.text=="export"){            
                item.submenu.forEach((ele)=>{
                    if(ele.text=="exportInvoices"){
                        item.submenu.splice(0, 2)
                    }
                })
            }
            this.menuItems.push(item);
        });
    }
    removeMenu(){
        this.menuItems=[]
    }

    getMenu() {
        return this.menuItems;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.service.ts